//BFSG
import * as React from 'react'
import * as t from './types'
import theme from 'theme'
import Card from 'theme/molecules/Card'
import Button from 'theme/atoms/Button'
import styled, { css } from 'styled-components'
import EecTracking from 'theme/atoms/EecTracking'
import withDy from './withDy'
import usePersonalization from 'hooks/usePersonalization'

export default withDy(function ContentTeaserVariants(props: t.Props) {
  const personalization = usePersonalization()
  return (
    <EecTracking config={props.eecTracking} gridArea={props.gridArea}>
      <Wrapper
        length={props.items.length}
        data-cy-ctx="organisms/ContentTeaserVariants"
      >
        <div className="headline-container">
          {props.title && (
            <h2 data-cy-state="show-title" className="headline">
              {props.title}
            </h2>
          )}
        </div>
        <div className="card-container">
          {props.context.items.slice(0, 4).map((item, index) => {
            return (
              <EecTracking
                config={item.tracking}
                gridArea={props.gridArea + '-item-' + (index + 1)}
                key={index}
              >
                <Card
                  title={item.title}
                  disclaimer={item.teaserText}
                  link={item.link}
                  showMoreText={item.showMoreText}
                  optImg={item.optImg}
                  teaserImage={item.teaserImage}
                />
              </EecTracking>
            )
          })}
        </div>
        <div className="button-wrapper">
          {props.buttonText && props.buttonLink && (
            <Button
              to={props.buttonLink}
              variation="cart"
              data-cy-state="has-show-more-button"
              onClick={() => personalization.trackClick()}
              data-cy-handle="show-more-button"
            >
              {props.buttonText}
            </Button>
          )}
        </div>
      </Wrapper>
    </EecTracking>
  )
})

const Wrapper = styled.div<{ length: number }>`
  > .headline-container {
    > .headline {
      ${theme.ty('rc-2xl', '400', 'rc-3xl')}
      margin-bottom: ${theme.spacing('m')};
    }
  }
  > .card-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: ${theme.spacing('ml')};
    grid-gap: ${theme.spacing('xs')};

    @media (min-width: ${theme.ms.MD}px) {
      grid-gap: ${theme.spacing('m')};
      margin-bottom: ${theme.spacing('ml')};
      ${(props) =>
        props.length % 2 === 0
          ? css`
              grid-template-columns: 1fr 1fr;
            `
          : css`
              grid-template-columns: 1fr 1fr 1fr;
            `}
    }
    @media (min-width: ${theme.ms.LG}px) {
      margin-bottom: ${theme.spacing('ml')};
      ${(props) =>
        props.length % 2 === 0
          ? css`
              grid-template-columns: 1fr 1fr 1fr 1fr;
            `
          : css`
              grid-template-columns: 1fr 1fr 1fr;
            `}
    }
    > .EecTracking {
      > .Card {
        max-width: 100%;
        min-width: 0;
        display: flex;
        justify-content: center;
        cursor: pointer;
        > div {
          background-color: ${theme.colors.shade.b7};
          overflow: hidden;
          width: 100%;
          > .teaser-image {
            background-position: center;
            height: 8.125rem;
            @media (min-width: ${theme.ms.MD}px) {
              height: 14.375rem;
            }
          }

          > .text-box {
            height: 7.5rem;
            padding: ${theme.spacing('xs')};
            @media (min-width: ${theme.ms.MD}px) {
              padding: ${theme.spacing('m')};
              height: 10rem;
            }
            > h3 {
              ${theme.ty('rc-base', null, 'rc-2xl')}
              padding: 0px;
              color: ${theme.colors.b0};
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-bottom: ${theme.spacing('xxs')};
            }
            > span {
              margin-top: ${theme.spacing('xxs')};
              color: ${theme.colors.b0};

              display: -webkit-box;
              max-width: 100%;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;

              ${theme.ty('r-s', null, 'r-base')}
            }
          }
          > .show-more-wrapper {
            padding: 0 ${theme.spacing('xs')} ${theme.spacing('xs')};

            @media (min-width: ${theme.ms.MD}px) {
              padding: 0 ${theme.spacing('m')} ${theme.spacing('m')};
            }

            > .show-more {
              ${theme.ty('rc-s', 'bold', 'r-base')}
              cursor: pointer;
              margin-right: ${theme.spacing('xs')};
            }
            > svg {
              vertical-align: text-bottom;
              width: 0.75rem;
            }
          }
        }
      }
    }

    ${(props) =>
      props.length % 2 === 1 &&
      css`
        > .EecTracking:nth-last-child(1) {
          grid-column: span 2;
          > .Card > div {
            > .teaser-image {
              height: 14.375rem;
            }
          }
        }
      `}
    @media (min-width: ${theme.ms.MD}px) {
      > .EecTracking:nth-last-child(1) {
        grid-column: unset;
      }
    }
  }
  > .button-wrapper {
    display: flex;
    justify-content: center;
    > span {
      width: 100%;
      max-width: 26.25rem;
    }
  }
`
